(function(){
    'use strict';
    angular.module('app').config(routesUrlConfig);

    routesUrlConfig.$inject = ['$routeProvider', '$locationProvider'];

    function routesUrlConfig($routeProvider, $locationProvider) {
        $routeProvider.
        when('/areas/routes/details/:id', {
            templateUrl: '/templates/pages/routes/route-details.html',
            controller: 'RouteDetailsController',
            controllerAs: 'vm',
            params: {
                parent:'areas',
                subParent: 'routes',
                htmlTitle: 'Area & Route',
                pageTitle: 'Area & Route',
                customHeader: true,
                icon: 'fa fa-pencil'
            }
        }).
        when('/areas/routes/add', {
            templateUrl: '/templates/pages/routes/route-details.html',
            controller: 'RouteDetailsController',
            controllerAs: 'vm',
            params: {
                parent:'areas',
                subParent: 'routes',
                htmlTitle: 'Area & Route',
                pageTitle: 'Area & Route',
                customHeader: true,
                icon: 'fa fa-pencil'
            }
        }).
        when('/areas/routes', {
            templateUrl: '/templates/pages/routes/routes.html',
            controller: 'RoutesController',
            controllerAs: 'vm',
            params: {
                parent:'areas',
                subParent: 'routes',
                htmlTitle: 'Area & Route',
                pageTitle: 'Area & Route',
                icon: 'fa fa-road',
            }
        }).
        when('/areas/add', {
            templateUrl: '/templates/pages/routes/areaDetails.html',
            controller: 'AreaDetailsController',
            controllerAs: 'vm',
            params: {
                parent:'areas',
                subParent: 'areas',
                htmlTitle: 'Area & Route',
                pageTitle: 'Area & Route',
                customHeader: true,
                icon: 'fa fa-road',
            }
        }).
        when('/areas/details/:id', {
            templateUrl: '/templates/pages/routes/areaDetails.html',
            controller: 'AreaDetailsController',
            controllerAs: 'vm',
            params: {
                parent:'areas',
                subParent: 'areas',
                htmlTitle: 'Area & Route',
                pageTitle: 'Area & Route',
                customHeader: true,
                icon: 'fa fa-road',
            }
        });

        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });
    }
})();


// WEBPACK FOOTER //
// ./js/urls/routes.js